const _SHARED = {
  wa_msgs: [
    { from: "u", text: "Quiero pedir un sushi 🍣" },
    { from: "c", text: "¡Hola! 😊 Nuestro Combo más pedido hoy:\n🍱 Combo Premium — €22\n¿Lo añado?" },
    { from: "u", text: "Sí, perfecto 👍" },
    { from: "c", text: "✅ Pedido #347 enviado a cocina\n⏱ Listo en ~20 min" },
  ],
  kds_note: "KDS · Nuevo pedido #347 → En preparación",
  kds_cols: [
    { l: "PENDIENTE", c: "#f59e0b" },
    { l: "EN PREP.", c: "#3b82f6" },
    { l: "LISTO ✓", c: "#22c55e" },
  ],
  dre_metrics: [
    { l: "Receita", v: "€8.240", d: "↑12%", c: "#22c55e" },
    { l: "CMV", v: "28%", d: "✅ Ok", c: "#22c55e" },
    { l: "Aluguel", v: "18%", d: "⚠️ Alto", c: "#f59e0b" },
    { l: "Margem", v: "54%", d: "↑", c: "#22c55e" },
  ],
  dre_alert: "Aluguel em 18% — acima do ideal (12%). Sugestão: renegociar ou aumentar ticket médio.",
  brain_actions: [
    "💡 Combo Sushi+Ramen — margem +€4,20/pedido",
    "📉 Terça: 40% menos → Happy Tuesday ativo",
    "⬆️ Temaki em destaque — maior margem do menu",
  ],
  menu_banner: "Carol recomenda 🔥",
};

export const T = {
  es: {
    ..._SHARED,
    panel_btn: "Mi panel",
    badge: "Programa de Socios Kaiso",
    footer: "Todos los derechos reservados",
    hero_title: ["Vende tecnología a restaurantes", "y gana", "comisión recurrente cada mes"],
    hero_sub: "Kaiso System automatiza atención, pedidos, cocina, financiero y decisiones con IA. Indica restaurantes y recibe 20% mientras el cliente esté activo.",
    hero_cta: "Ir a mi panel",
    hero_cta2: "Ver diferenciales",
    hero_stats: ["20% recurrente", "Sin límite de clientes", "Pago mensual automático"],
    diff_title: "5 razones por las que los restaurantes compran",
    diff_sub: "Muestra estas pantallas y deja que el sistema venda solo.",
    cards: [
      { tag: "Carol IA", badge: "WhatsApp + IA", title: "La IA atiende, toma pedidos y los envía a la cocina sola", body: "El cliente escribe en WhatsApp, Carol recomienda, crea el pedido y lo manda al KDS. Sin intervención humana." },
      { tag: "Menú Digital", badge: "Conversión +8%", title: "Menú visual que convierte más que uno tradicional", body: "Productos en destaque, sin comisiones de terceros, pedido desde el móvil. El cliente pide solo." },
      { tag: "KDS", badge: "Cero papel", title: "Pedidos de WhatsApp, QR y online van directo a la cocina", body: "Sin gritos, sin papel, sin errores. Todo lo que entra al sistema aparece en pantalla al instante." },
      { tag: "IA Ejecutiva", badge: "DRE inteligente", title: "La IA analiza el negocio y dice dónde está perdiendo dinero", body: "CMV, alquiler, margen real y alertas automáticas. El sistema no solo muestra números — dice qué hacer." },
      { tag: "Ventas IA", badge: "Piloto automático", title: "El sistema activa promociones en los días débiles solo", body: "Kaiso Brain detecta caídas de ventas y activa estrategias automáticamente. El dueño no hace nada extra." },
    ],
    sell_title: "Cómo puedes vender",
    sell_sub: "Copia estas frases y úsalas directamente — funcionan.",
    channels: [
      { icon: "🤝", ch: "Visita presencial", phrase: "¿Puedo mostrarte en 10 min cómo tu restaurante atiende clientes en WhatsApp sin contratar a nadie?" },
      { icon: "💬", ch: "WhatsApp", phrase: "Hola [nombre], vi tu restaurante en [ciudad]. ¿Quieres ver cómo restaurantes como el tuyo están automatizando pedidos con IA?" },
      { icon: "📸", ch: "Instagram", phrase: "¿Tu restaurante aún pierde pedidos en WhatsApp? Hay una solución. Escríbeme." },
      { icon: "🎯", ch: "Tráfico pago", phrase: "Restaurante en [ciudad] — ¿Sabes cuánto pierdes sin un sistema inteligente de pedidos?" },
      { icon: "🌟", ch: "Indicación directa", phrase: "Un conocido usa Kaiso y aumentó ventas 30%. ¿Quieres que te cuente cómo funciona?" },
    ],
    args_title: "Preguntas que abren la venta",
    args_sub: "Genera curiosidad con estas frases:",
    args: [
      "«¿Tu restaurante todavía pierde pedidos en el WhatsApp?»",
      "«¿Sabes cuál producto te da más margen real?»",
      "«¿Tu cocina recibe pedidos automáticamente o alguien los anota?»",
      "«¿Tu sistema toma decisiones o solo registra ventas?»",
    ],
    com_title: "Tu comisión crece con tu cartera",
    com_sub: "20% del plan, cada mes, mientras el cliente esté activo.",
    tiers: [
      { l: "5 clientes", mo: "€300", s: "Ingreso extra sólido" },
      { l: "20 clientes", mo: "€1.200", s: "Ingreso principal" },
      { l: "50 clientes", mo: "€3.000", s: "Cartera premium" },
    ],
    com_note: "Ejemplo con plan medio de €60/mes. Mientras el cliente permanezca activo, tú sigues recibiendo — sin hacer nada adicional.",
    cta_title: "Empieza hoy",
    cta_sub: "Copia tu enlace y compártelo con el primer restaurante.",
    cta_btn: "Ir a mi panel y copiar mi enlace →",
    support_title: "¿Dudas sobre cómo vender?",
    support_body: "Nuestro equipo te ayuda a cerrar tu primer cliente.",
    support_wa_label: "Soporte WhatsApp",
    support_email_label: "Soporte Email",
  },
  pt: {
    ..._SHARED,
    panel_btn: "Meu painel",
    badge: "Programa de Parceiros Kaiso",
    footer: "Todos os direitos reservados",
    hero_title: ["Venda tecnologia para restaurantes", "e ganhe", "comissão recorrente todo mês"],
    hero_sub: "O Kaiso System automatiza atendimento, pedidos, cozinha, financeiro e decisões com IA. Você indica restaurantes e recebe 20% enquanto o cliente estiver ativo.",
    hero_cta: "Ir para meu painel",
    hero_cta2: "Ver diferenciais",
    hero_stats: ["20% recorrente", "Sem limite de clientes", "Pagamento mensal automático"],
    diff_title: "5 motivos pelos quais restaurantes compram",
    diff_sub: "Mostre estas telas e deixe o sistema vender por você.",
    cards: [
      { tag: "Carol IA", badge: "WhatsApp + IA", title: "A IA atende, cria pedidos e envia para a cozinha sozinha", body: "O cliente escreve no WhatsApp, Carol recomenda, cria o pedido e manda para o KDS. Sem intervenção humana." },
      { tag: "Menu Digital", badge: "Conversão +8%", title: "Menu visual que converte mais que o tradicional", body: "Produtos em destaque, sem comissões de terceiros, pedido pelo celular. O cliente pede sozinho." },
      { tag: "KDS", badge: "Zero papel", title: "Pedidos do WhatsApp, QR e online vão direto para a cozinha", body: "Sem gritos, sem papel, sem erros. Tudo que entra no sistema aparece na tela na hora." },
      { tag: "IA Executiva", badge: "DRE inteligente", title: "A IA analisa o negócio e mostra onde está perdendo dinheiro", body: "CMV, aluguel, margem real e alertas automáticos. O sistema não só mostra números — diz o que fazer." },
      { tag: "Vendas IA", badge: "Piloto automático", title: "O sistema ativa promoções nos dias fracos sozinho", body: "O Kaiso Brain detecta quedas de vendas e ativa estratégias automaticamente. O dono não precisa fazer nada extra." },
    ],
    sell_title: "Como você pode vender",
    sell_sub: "Copie estas frases e use diretamente — funcionam.",
    channels: [
      { icon: "🤝", ch: "Visita presencial", phrase: "Posso te mostrar em 10 min como seu restaurante atende clientes no WhatsApp sem contratar ninguém?" },
      { icon: "💬", ch: "WhatsApp", phrase: "Olá [nome], vi seu restaurante em [cidade]. Quer ver como restaurantes como o seu estão automatizando pedidos com IA?" },
      { icon: "📸", ch: "Instagram", phrase: "Seu restaurante ainda perde pedido no WhatsApp? Tem solução. Me chama." },
      { icon: "🎯", ch: "Tráfego pago", phrase: "Restaurante em [cidade] — Sabe quanto você perde sem um sistema inteligente de pedidos?" },
      { icon: "🌟", ch: "Indicação direta", phrase: "Um conhecido usa o Kaiso e aumentou as vendas 30%. Quer que eu conte como funciona?" },
    ],
    args_title: "Perguntas que abrem a venda",
    args_sub: "Gere curiosidade com estas frases:",
    args: [
      "«Seu restaurante ainda perde pedido no WhatsApp?»",
      "«Você sabe qual produto te dá mais margem real?»",
      "«Sua cozinha recebe pedidos automaticamente ou alguém anota?»",
      "«Seu sistema toma decisões ou só registra vendas?»",
    ],
    com_title: "Sua comissão cresce com sua carteira",
    com_sub: "20% do plano, todo mês, enquanto o cliente estiver ativo.",
    tiers: [
      { l: "5 clientes", mo: "€300", s: "Renda extra sólida" },
      { l: "20 clientes", mo: "€1.200", s: "Renda principal" },
      { l: "50 clientes", mo: "€3.000", s: "Carteira premium" },
    ],
    com_note: "Exemplo com plano médio de €60/mês. Enquanto o cliente permanecer ativo, você continua recebendo — sem fazer nada adicional.",
    cta_title: "Comece hoje",
    cta_sub: "Copie seu link e compartilhe com o primeiro restaurante.",
    cta_btn: "Ir para meu painel e copiar meu link →",
    support_title: "Dúvidas sobre como vender?",
    support_body: "Nossa equipe te ajuda a fechar seu primeiro cliente.",
    support_wa_label: "Suporte WhatsApp",
    support_email_label: "Suporte Email",
  },
  en: {
    ..._SHARED,
    panel_btn: "My panel",
    badge: "Kaiso Partner Program",
    footer: "All rights reserved",
    hero_title: ["Sell restaurant technology", "and earn", "recurring commission every month"],
    hero_sub: "Kaiso System automates service, orders, kitchen, financials and decisions with AI. Refer restaurants and receive 20% as long as the client stays active.",
    hero_cta: "Go to my panel",
    hero_cta2: "See features",
    hero_stats: ["20% recurring", "Unlimited clients", "Automatic monthly payment"],
    diff_title: "5 reasons restaurants buy",
    diff_sub: "Show these screens and let the system sell itself.",
    cards: [
      { tag: "Carol AI", badge: "WhatsApp + AI", title: "AI that takes orders and sends them to the kitchen alone", body: "Customer writes on WhatsApp, Carol recommends, creates the order and sends it to KDS. No human needed." },
      { tag: "Digital Menu", badge: "+8% conversion", title: "Visual menu that converts more than a traditional one", body: "Featured products, no third-party fees, order from mobile. Customers order themselves." },
      { tag: "KDS", badge: "Zero paper", title: "WhatsApp, QR and online orders go straight to the kitchen", body: "No shouting, no paper, no errors. Everything that enters the system appears on screen instantly." },
      { tag: "Executive AI", badge: "Smart P&L", title: "AI analyzes the business and shows where money is being lost", body: "COGS, rent, real margin and automatic alerts. The system doesn't just show numbers — it says what to do." },
      { tag: "AI Sales", badge: "Autopilot", title: "System activates promotions on slow days automatically", body: "Kaiso Brain detects sales drops and activates strategies automatically. The owner does nothing extra." },
    ],
    sell_title: "How to sell",
    sell_sub: "Copy these phrases and use them directly — they work.",
    channels: [
      { icon: "🤝", ch: "In-person visit", phrase: "Can I show you in 10 min how your restaurant handles WhatsApp orders without hiring anyone?" },
      { icon: "💬", ch: "WhatsApp", phrase: "Hi [name], I saw your restaurant in [city]. Want to see how restaurants like yours are automating orders with AI?" },
      { icon: "📸", ch: "Instagram", phrase: "Is your restaurant still losing orders on WhatsApp? There's a solution. Message me." },
      { icon: "🎯", ch: "Paid traffic", phrase: "Restaurant in [city] — Do you know how much you're losing without a smart ordering system?" },
      { icon: "🌟", ch: "Direct referral", phrase: "A friend uses Kaiso and grew sales by 30%. Want me to tell you how it works?" },
    ],
    args_title: "Questions that open the sale",
    args_sub: "Generate curiosity with these phrases:",
    args: [
      "«Is your restaurant still losing WhatsApp orders?»",
      "«Do you know which product gives you the most real margin?»",
      "«Does your kitchen receive orders automatically or does someone write them down?»",
      "«Does your system make decisions or just record sales?»",
    ],
    com_title: "Your commission grows with your portfolio",
    com_sub: "20% of the plan, every month, while the client stays active.",
    tiers: [
      { l: "5 clients", mo: "€300", s: "Solid extra income" },
      { l: "20 clients", mo: "€1.200", s: "Main income" },
      { l: "50 clients", mo: "€3.000", s: "Premium portfolio" },
    ],
    com_note: "Example with average plan of €60/month. As long as the client stays active, you keep receiving — without doing anything extra.",
    cta_title: "Start today",
    cta_sub: "Copy your link and share it with the first restaurant.",
    cta_btn: "Go to my panel and copy my link →",
    support_title: "Questions about selling?",
    support_body: "Our team helps you close your first client.",
    support_wa_label: "WhatsApp support",
    support_email_label: "Email support",
  },
};
